import { hasMaxLength, hasMinLength, isMatchRegex, isRequired } from 'utils/validation';
import { replacePhoneMask } from 'utils/string/replaceMasks';
import { EMAIL_REGEX } from 'commons/constants';
import type { FormStructureItem } from 'utils/form/Form.types';
import type { ValidatorSet } from 'utils/validation/Validation.types';

export const formStructure: FormStructureItem[] = [
  {
    id: 'firstName',
    displayName: 'First Name',
  },
  {
    id: 'lastName',
    displayName: 'Last Name',
  },
  {
    id: 'phone',
    displayName: 'Phone Number',
    maxLength: 10,
    minLength: 10,
    masks: [replacePhoneMask],
  },
  {
    id: 'postalCode',
    displayName: 'Postal Code',
  },
  {
    id: 'email',
    displayName: 'Email',
  },
];
export const formValidators: ValidatorSet = {
  firstName: [
    {
      validator: isRequired,
    },
  ],
  lastName: [
    {
      validator: isRequired,
    },
  ],
  phone: [
    {
      validator: isRequired,
    },
    {
      validator: hasMinLength,
      minLength: 10,
      outputName: 'Phone number',
    },
    {
      validator: hasMaxLength,
      maxLength: 10,
      outputName: 'Phone number',
    },
  ],
  postalCode: [
    {
      validator: isRequired,
    },
  ],
  email: [
    {
      validator: isRequired,
    },
    {
      validator: isMatchRegex,
      regex: EMAIL_REGEX,
      outputName: 'email',
    },
  ],
};
